export enum EDailyrentActionType {
  /** Возможность связаться напрямую **/
  'Contact' = 'contact',
  /** Бронирование **/
  'OtaBooking' = 'otaBooking',
  /** Проверка дат **/
  'OtaCheckDates' = 'otaCheckDates',
  /** Забронировать партнёрский объект **/
  'PartnerBooking' = 'partnerBooking',
  /** Проверка дат у партнёрского объекта **/
  'PartnerCheckDates' = 'partnerCheckDates',
  /** Только чат **/
  'Chat' = 'chat',
}

export type TDailyrentGuestsInfo = {
  /** Количество гостей **/
  guestsCount: number;
  /** Максимальное количество гостей **/
  maxGuestsCount: number;
};

export type TDailyrentRating = {
  /** Оценка объявления **/
  rating: string | null;
  /** Кол-во отзывов **/
  reviewsCount: string | null;
};

export type TDailyrentHotelData = {
  /** Показатель является ли объявление отелем **/
  isHotel: boolean;
  /** Название отеля **/
  hotelName: string | null;
  /** Информер под ценой **/
  priceSubtitle: string | null;
  /** Кол-во звезд у отеля **/
  starRating: string | null;
};

export type TDailyrent = {
  /** Тип действия для кнопки **/
  actionType: EDailyrentActionType;
  /** Данные о отеле **/
  hotelData: TDailyrentHotelData;
  /** Есть ли подключение ОТА **/
  isOnlineBooking: boolean;
  /** Проверено ЦИАН **/
  isVerifiedByCian: boolean;
  /** Идентификатор объявления **/
  realtyId: number;
  /** Информация о гостях **/
  guestsInfo: TDailyrentGuestsInfo | null;
  /** Рейтинг и кол-во отзывов у объявления **/
  rating: TDailyrentRating | null;
};
